<script>
  import DropDown from '../DropDown.svelte';
  import CreateGroup from './CreateGroup.svelte';
  import TaskGroup from './TaskGroup.svelte';
  import { client } from 'root/api/index.js';
  import DatePicker from '../Flatpickr/DatePicker.svelte';
  import { Modal } from 'bootstrap';
  import {
    downloadCsvFile,
    searchKeyByValue,
    configItem,
    dbDateFormat,
  } from 'components/Helper.js';
  // export let unitUsers;
  import Loader from '../Loader.svelte';

  import { getContext, onMount, createEventDispatcher } from 'svelte';

  import * as yup from 'yup';
  import InfoAlert from '../Alert/InfoAlert.svelte';

  // export let clientUnitUsers;
  // export let dashboardLeftObj;
  import { createForm } from 'svelte-forms-lib';
  import FormInput from '../FormControls/FormInput.svelte';
  export let showSaveButton = false;
  export let filterSelected = false;
  export let filter = {};
  export let type = '';
  export let filterId = 0;
  export let editButton = false;
  const dispatch = createEventDispatcher();

  import { dashboardData, getDashboardData, setDashboardData } from '../../stores/dashboard.js';
  // export let setDashboardFilter;
  // export let extraFilter;
  // export let changeFilter;

  // export let  fromToRange= "";
  let serverErrors = [];
  let isFormPending = false;
  let saveType = '';

  $: editButton && editButtonClick();

  const editButtonClick = () => {
    if (editButton == true) {
      getDetail(filterId);
    }
  };

  // import { getContext } from "svelte";
  const showDialog = getContext('showDialog');

  let defaultValue = {
    id: '',
    name: '',
  };
  // export let showDate=false
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      name: yup.string().required('Name is required'),
    }),
    onSubmit: (values) => {
      isFormPending = true;

      if (filterSelected == true || editButton == false) {
        values.filterData = filter;
      }
      values.type = type;

      client
        .filterReportAdd({ ...values })
        .then((response) => {
          isFormPending = false;
          toggleModal('hide');
          // showSaveButton=false;
          // filterData()
          dispatch('onSave', response.data);
          // getMaster()
        })
        .catch((err) => {
          isFormPending = false;
          serverErrors = [err.message];
        });
    },
  });
  let formData = {};
  const getDetail = (id) => {
    dispatch('onClick');
    $form = { ...defaultValue };
    $errors = {};
    serverErrors = [];

    if (id > 0) {
      client
        .filterReportGet({ id })
        .then((response) => {
          $form = response.data;
          formData = response.data;
          toggleModal();
        })
        .catch((err) => {});
    } else {
      toggleModal();
    }
  };

  function toggleModal(flag) {
    if (flag != undefined && flag == 'hide') {
      var modal = Modal.getInstance(document.getElementById('projectTypeModal'));
      modal.hide();
      dispatch('hide');
    } else {
      var modal = new Modal(document.getElementById('projectTypeModal'), {
        keyboard: false,
        backdrop: 'static',
      });
      modal.show();
    }
  }

  let focusInput;
  onMount(() => {
    document.getElementById('projectTypeModal').addEventListener('shown.bs.modal', function () {
      focusInput.focusOnInput();
    });
  });
</script>

{#if showSaveButton}
  <button
    type="button"
    class="task-filter-icon btn btn-primary border-0 px-2 rounded ms-2 text-nowrap font-size-13"
    on:click={() => {
      getDetail(filterId);
      editButton = false;
    }}
  >
    {#if filterSelected}
      Update
    {:else}
      Save
    {/if} Report
  </button>
{/if}
<!-- Modal -->
<div
  class="modal fade"
  id="projectTypeModal"
  tabindex="-1"
  aria-labelledby="projectTypeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5
          class="modal-title font-size-14"
          id="projectTypeModalLabel"
        >
          {$form.id != undefined && $form.id > 0 ? 'Update' : 'Add'} Report
        </h5>
        <button
          data-bs-dismiss="modal"
          type="button"
          class="btn-close"
          aria-label="Close"
          on:click={() => {
            dispatch('hide');
          }}
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <InfoAlert
            message={serverErrors}
            class="alert alert-danger w-100 mb-3"
          />
          {#if filterSelected && editButton == false}
            <div class="col mb-3">
              <div class="form-label mb-0">
                <div class="radio c-radio">
                  <label class="text-nowrap">
                    <input
                      type="radio"
                      name="saveType"
                      checked={filterSelected == true}
                      on:change={(event) => {
                        $form.id = filterId;
                        saveType = 1;
                      }}
                    />
                    <span class="check-img" />
                    Update
                  </label>
                </div>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-label mb-0">
                <div class="radio c-radio">
                  <label class="text-nowrap">
                    <input
                      type="radio"
                      name="saveType"
                      on:change={(event) => {
                        $form.id = '';
                        saveType = 0;
                      }}
                    />
                    <span class="check-img" />
                    Add New
                  </label>
                </div>
              </div>
            </div>
          {/if}
          <div class="col-md-12">
            <div class="form-group mb-3">
              <FormInput
                name="name"
                label="Report"
                maxLength={configItem.maxLength.masterInput}
                type="text"
                placeholder="Enter Report Name "
                error={$errors.name}
                keypress={(event) => {
                  if (event.key == 'Enter') {
                    handleSubmit();
                  }
                }}
                bind:value={$form.name}
                handleChange={handleChange}
                bind:this={focusInput}
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button
          on:click={handleSubmit}
          type="button"
          class="btn btn-primary font-size-13 px-4"
          disabled={isFormPending}
        >
          {#if isFormPending}
            <Loader />
          {:else if saveType == 1}Update
          {:else}Save{/if}
        </button>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .customer-group-picker {
    margin-left: 37px;
    margin-right: 37px;
  }
  .task-filter-icon {
    img {
      width: 16px;
      height: 16px;
    }
  }
  .date-picker {
    width: 220px;
  }
</style>
